import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import flechaAvanzar from "../assets/right-arrow.svg";
import fepolLogo from "../assets/logo.webp";
import { ROUTES } from "../utils/constants";
import { clearItem, getGroupTable } from "../utils/helpers";
import { alertResume, modalText } from "../utils/logger";
import { useMedia } from "../contexts/MediaContext";
import "./Home.css";

const AVISO_LEGAL = `<div class="mt-2 home-legal-modal">
<h2>Aviso legal</h2>

<p><strong>Titular del sitio y de la aplicación</strong><br/>
El titular de este sitio web y de la aplicación de dinámica formativa es <strong>OWIUS TECHNOLOGIES, S.L.</strong>, sociedad española con domicilio en <strong>C/ Sardenya, 229, 4.ª planta</strong>, Barcelona (España), con C.I.F. <strong>B67030593</strong>. Correo de contacto: <a href="mailto:info@owius.com">info@owius.com</a>.</p>

<p><strong>Objeto</strong><br/>
La plataforma tiene fines formativos y de simulación clínica en entornos controlados (por ejemplo, sesiones con grupos de profesionales sanitarios). El contenido y los casos clínicos se ofrecen como apoyo didáctico y <strong>no sustituyen el criterio clínico independiente</strong>, las guías oficiales ni la relación médico-paciente.</p>

<p><strong>Condiciones de uso</strong><br/>
El acceso y uso de la aplicación implican la aceptación de este aviso. El usuario se compromete a utilizar la plataforma de forma lícita, respetando la normativa aplicable, la dignidad de las personas y los derechos de terceros. Queda prohibido cualquier uso que pueda dañar, inutilizar o sobrecargar los sistemas, o que vulnere la seguridad o la confidencialidad de los datos.</p>

<p><strong>Propiedad intelectual e industrial</strong><br/>
Los elementos que integran el diseño de la aplicación, el código, la base de datos, los textos, imágenes, marcas y demás contenidos son titularidad de OWIUS TECHNOLOGIES, S.L. o de sus licenciantes, salvo indicación expresa en contrario. No se autoriza su reproducción, distribución, comunicación pública o transformación sin consentimiento previo y por escrito del titular.</p>

<p><strong>Limitación de responsabilidad</strong><br/>
OWIUS TECHNOLOGIES, S.L. pone medios razonables para mantener la plataforma operativa y la información actualizada, pero no garantiza la ausencia de interrupciones, errores técnicos o la exactitud absoluta de todos los contenidos. En la medida permitida por la ley, OWIUS TECHNOLOGIES, S.L. no será responsable de los daños y perjuicios derivados del uso de la aplicación, salvo en caso de dolo o culpa grave.</p>

<p><strong>Enlaces a terceros</strong><br/>
Si la aplicación incluyera enlaces a sitios externos, estos se facilitan únicamente a efectos informativos. OWIUS TECHNOLOGIES, S.L. no controla ni se responsabiliza del contenido de dichos sitios.</p>

<p><strong>Ley aplicable y jurisdicción</strong><br/>
Las presentes condiciones se rigen por la legislación española. Para la resolución de controversias, las partes se someten a los juzgados y tribunales de <strong>Barcelona</strong>, salvo que la normativa imperativa en materia de consumidores disponga otro fuero.</p>

<p><strong>Modificaciones</strong><br/>
OWIUS TECHNOLOGIES, S.L. se reserva el derecho a modificar este aviso legal. La versión vigente será la publicada en la aplicación en cada momento.</p>

<p>&copy; ${new Date().getFullYear()} OWIUS TECHNOLOGIES, S.L. Todos los derechos reservados.</p>
</div>`;

const POLITICA_PRIVACIDAD = `<div class="mt-2 home-legal-modal">
<h2>Política de privacidad</h2>

<p><strong>Responsable del tratamiento</strong><br/>
<strong>OWIUS TECHNOLOGIES, S.L.</strong><br/>
C/ Sardenya, 229, 4.ª planta, Barcelona (España)<br/>
C.I.F. B67030593<br/>
Correo: <a href="mailto:info@owius.com">info@owius.com</a></p>

<p><strong>Finalidad del tratamiento</strong><br/>
Tratamos los datos identificativos y, en su caso, la imagen de equipo y los nombres de los participantes que se introducen en el registro, así como los datos de uso de la dinámica (respuestas, puntuaciones, tiempos, identificador de juego y mesa), con las siguientes finalidades: (1) gestionar la participación en la sesión formativa; (2) generar estadísticas agregadas para la organización del evento; (3) mantener la seguridad y el correcto funcionamiento técnico del servicio.</p>

<p><strong>Base legal</strong><br/>
El tratamiento se basa en la ejecución de medidas precontractuales y contractuales con la entidad organizadora del evento o en el interés legítimo de OWIUS para la prestación del servicio tecnológico, y, cuando corresponda, en el consentimiento del interesado para comunicaciones adicionales.</p>

<p><strong>Conservación</strong><br/>
Los datos se conservarán durante el tiempo necesario para cumplir las finalidades indicadas y las obligaciones legales aplicables. Transcurridos dichos plazos, serán suprimidos o anonimizados.</p>

<p><strong>Destinatarios</strong><br/>
No cederemos sus datos a terceros salvo obligación legal o encargo a proveedores que actúen en nombre de OWIUS (por ejemplo, alojamiento o soporte técnico), con quienes se formalizan las obligaciones exigidas por la normativa de protección de datos.</p>

<p><strong>Transferencias internacionales</strong><br/>
En caso de que algún proveedor tratara datos fuera del Espacio Económico Europeo, OWIUS adoptará las garantías previstas en el Reglamento (UE) 2016/679 (cláusulas contractu tipo u otras mecanismos válidos).</p>

<p><strong>Derechos</strong><br/>
Puede ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad cuando proceda, así como retirar el consentimiento en cualquier momento, dirigiendo un correo a <a href="mailto:info@owius.com">info@owius.com</a>, acreditando su identidad. Tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (<a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>).</p>

<p><strong>Medidas de seguridad</strong><br/>
OWIUS aplica medidas técnicas y organizativas adecuadas para proteger los datos frente a accesos no autorizados, pérdida o alteración.</p>

<p><strong>Menores</strong><br/>
El servicio está dirigido a profesionales y entornos formativos. No está concebido para recabar datos de menores de edad.</p>

<p><strong>Actualización</strong><br/>
Esta política puede actualizarse. Le recomendamos revisarla periódicamente. Última actualización: ${new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" })}.</p>
</div>`;

function Home() {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const gameId = searchParams.get("game");
	const { unlockAllMedia } = useMedia();

	useEffect(() => {
		if (getGroupTable()) {
			if (gameId) {
				alertResume().then((res) => {
					if (res.isConfirmed) {
						navigate(ROUTES.REGISTER);
					} else {
						clearItem("groupTable");
						clearItem("total");
					}
				});
			} else {
				navigate(ROUTES.REGISTER);
			}
		} else {
			clearItem("total");
		}
	}, []);

	const handleStartClick = async () => {
		if (loading) return;
		setLoading(true);
		try {
			await unlockAllMedia();
			navigate(ROUTES.REGISTER, {
				state: { game: gameId },
			});
		} catch (error) {
			console.error("Error al desbloquear medios:", error);
			navigate(ROUTES.REGISTER, {
				state: { game: gameId },
			});
		} finally {
			setLoading(false);
		}
	};

	const openLegal = () => {
		modalText({
			title: "Aviso legal",
			html: AVISO_LEGAL,
		});
	};

	const openPrivacy = () => {
		modalText({
			title: "Política de privacidad",
			html: POLITICA_PRIVACIDAD,
		});
	};

	return (
		<div className="home-page">
			<div className="home-inner">
				<main className="home-main">
					<h1 className="home-headline">
						<img
							className="home-headline-logo"
							src={fepolLogo}
							alt="Planeta"
							decoding="async"
							fetchpriority="high"
						/>
					</h1>
					<button
						type="button"
						className="home-cta"
						onClick={handleStartClick}
						disabled={loading}
						aria-busy={loading}
						aria-label={loading ? "Cargando" : "Entrar al registro"}
					>
						{loading ? (
							<span className="home-cta-spinner" aria-hidden />
						) : (
							<img src={flechaAvanzar} alt="" />
						)}
					</button>
				</main>

				<footer className="home-footer">
					<div className="home-footer-links">
						<button type="button" onClick={openLegal}>
							Aviso legal
						</button>
						<span className="home-footer-sep" aria-hidden>
							|
						</span>
						<button type="button" onClick={openPrivacy}>
							Política de privacidad
						</button>
					</div>
				</footer>
			</div>
		</div>
	);
}

export default Home;
